import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { TruncatedText } from '@/components/common/truncated-text';
import { formatNumberWithCommas } from '@/utils/format-number-with-commas';
import { agentOrderHooks } from '@/manager';
import { FinishIcon, TotalCountIcon, TotalMoneyIcon } from './assets';
import { Skeleton } from '../ui/skeleton';
import { cn } from '@/lib/utils';

/** 智能体订单管理-卡片概览 */
export const DataOverview: React.FC = () => {
  const { t } = useTranslation();
  const { orderStatsData, loading } = agentOrderHooks.useOrderStats();

  // 统计数据
  const stats = useMemo(() => [
    {
      title: t('agent_dashboard.order_management.total_order'),
      count: orderStatsData?.totalOrderCount,
      icon: <TotalCountIcon />,
    },
    {
      title: t('agent_dashboard.order_management.finished_order'),
      count: orderStatsData?.completedOrderCount,
      icon: <FinishIcon />,
    },
    {
      title: t('agent_dashboard.order_management.total_transaction'),
      count: orderStatsData?.totalAmount,
      icon: <TotalMoneyIcon />,
    },
  ], [orderStatsData]);

  return (
    <div className='flex gap-5 flex-col lg:flex-row'>
      {stats.map((stat, index) => {
        const isMoney = index == 2;
        return (
          <div
            key={index}
            className='min-w-[22rem] max-w-[22rem] bg-white rounded-lg  border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'
          >
            <div className={`size-10 border border-[rgba(213,215,218,1)] rounded-md flex items-center justify-center shadow-sm flex-shrink-0`}>
              {stat.icon}
            </div>
            <div className='w-full flex-1 space-y-2'>
              <div className='text-sm text-[rgba(102,112,133,1)] font-semibold'>{stat.title}</div>
              {loading && <Skeleton className={cn('h-9 w-20 rounded', index === 2 && 'w-32')} />}
              {!loading && <div className='text-3xl font-semibold text-[rgba(16,24,40,1)]'>
                <TruncatedText
                  className='max-w-[90%]'
                  text={isMoney
                    ? `$${formatNumberWithCommas({ num: stat.count })}`
                    : stat.count.toString()}
                />
              </div>}
            </div>
          </div>
        )
      })}
    </div>
  )
}

const SkeletonCard = () => (
  <div className='w-[22rem] max-w-[22rem] bg-white rounded-lg border border-[rgba(233,234,235,1)] p-6 py-6 flex space-x-4 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]'>
    <div className='size-10  rounded-md flex items-center justify-center flex-shrink-0'>
      <div className='size-10 bg-[rgba(233,234,235,1)] rounded animate-pulse'></div>
    </div>
    <div className='flex-1 space-y-2'>
      <div className='h-6 bg-[rgba(233,234,235,1)] rounded animate-pulse w-24'></div>
      <div className='h-8 bg-[rgba(233,234,235,1)] rounded animate-pulse w-16'></div>
    </div>
  </div>
);